import { Country } from '@commenda/prisma';
import { ServiceRequestContextFor, TSalesTaxFlow } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export const createServiceRequest = async <
  TFlow extends TSalesTaxFlow | undefined = undefined,
>(params: {
  /** Starts a sales-tax flow, whose request gets the service of where it's made. */
  salesTaxFlow?: TFlow;
  companyId: number;
  explicitTitle?: string;
  corporationId?: number;
  explicitCountry?: Country;
  serviceCompositeId?: string;
  metadata?: Record<string, unknown>;
  context?: TFlow extends TSalesTaxFlow
    ? ServiceRequestContextFor<TFlow>
    : Record<string, unknown>;
  transferPricingBenchmarkId?: string;
  assignedBusinessEntityIds?: number[];
  assignedAgentFirmUserId?: string;
}): Promise<{ success: boolean; data?: { id: string } }> => {
  const response = await fetcher(
    `${API_BASE_PATH}/`,
    {
      method: 'POST',
      body: params,
    },
    undefined
  );

  if (!response.ok) return { success: false };

  const responseData = (await response.json()) as { id: string };
  if (!responseData.id) return { success: false };

  return { success: true, data: { id: responseData.id } };
};
